<template>
  <main class="page">
    <AppBack/>

    <AppPageHeader
      :title="isCreate ? 'Создать путевой лист' : 'Редактировать путевой лист'"
    />

    <section class="section">
      <!-- TODO сделать нормальную форму и валидацию -->
      <div class="form__bg">
        <h2 class="subtitle">Основная информация</h2>

        <div class="form__inputs">
          <AppInputDate title="Дата путевого листа"
                        type="single"
                        :value="waybill.date_at"
                        :valid="validation.date_at"
                        required
                        @value-changed="setDateAt"
                        @got-focus="clearValidation('date_at')"
          />

          <AppInput title="Номер путевого листа"
                    required
                    :value="waybill.code"
                    :valid="validation.code"
                    @value-changed="setCode"
                    @got-focus="clearValidation('code')"
          />

          <VSelect
            label="Водитель"
            :value="waybill.driver"
            ref="driver"
            name="driver"
            item-text="full_name"
            :items="driverList"
            :handler-search="GETLogisticDriverList"
            search
            required
            @change="setDriver"
          >
            <Validation for="required">Выберете водителя</Validation>
          </VSelect>

          <VSelect
            label="Транспорт"
            :value="waybill.transport"
            ref="transport"
            name="transport"
            :items="waybillDriverTransports || transportList"
            :handler-search="waybillDriverTransports ? null : GETLogisticTransportList"
            search
            required
            @change="setTransport"
          >
            <Validation for="required">Выберете транспорт</Validation>
          </VSelect>
        </div>

        <h2 class="subtitle">Пробег и топливо</h2>

        <div class="form__inputs">
          <AppInput title="Стартовое значение пробега"
                    :value="waybill.distance_start"
                    @value-changed="setDistanceStart"
          />
          <AppInput title="Конечное значение пробега"
                    :value="waybill.distance_end"
                    @value-changed="setDistanceEnd"
          />
          <p></p>
          <p class="waybill__distance-set" style="text-align: right;">Пройденная дистанция: <strong>{{waybill.distance_set}}</strong></p>
        </div>

        <transition name="fade">
          <LogisticWaybillFuels :fuels="waybill.fuel_balance"
                                v-if="waybill.fuel_balance.length"
                                class="mb-40"
                                @set-balance-add="setBalanceAdd"
                                @set-balance-at="setBalanceAt"
                                @set-balance-to="setBalanceTo"
          />
        </transition>

        <h2 class="subtitle">Дополнительная информация</h2>

        <div class="form__inputs">
          <AppInputDate title="Старт работ"
                        type="single"
                        timer
                        required
                        :value="waybill.start_at"
                        :valid="validation.start_at"
                        @value-changed="setStartAt"
                        @got-focus="clearValidation('start_at')"
          />
          <AppInputDate title="Окончание работ"
                        type="single"
                        timer
                        required
                        :value="waybill.end_at"
                        :valid="validation.end_at"
                        @value-changed="setEndAt"
                        @got-focus="clearValidation('end_at')"
          />
        </div>
      </div>

      <div class="table__buttons">
        <h2 class="subtitle" style="margin-right: auto">
          Выезды\работы
        </h2>

        <transition name="fade">
          <AppButtonSmRemove style="margin-right: 20px" title="Удалить"
                             v-if="workIsActiveDelete"
                             @click.native="deleteSelectedWorks"
          />
        </transition>

        <AppButtonSmAdd title="Создать"
                        @click.native="openWorkModal(null)"
        />
      </div>

      <AppTable v-if="work.length"
                :isMenuControlsActive="false"
                :data="work"
                :headers="workHeaders.headers"
                :has-checkbox="true"
                :all-items-active="workHeaders.allActive"
                @toggle-active-item="toggleActiveItem"
                @toggle-active-all="toggleActiveAll"
                @edit-this-item="openWorkModal"
                @show-this-item="openWorkModal"
                style="max-height: 100%"
      />

      <AppNoRecordsPlaceholder v-else />
    </section>

    <div class="page__footer d-flex gap-16">
      <AppButton
        :title="isCreate ? 'Создать' : 'Сохранить'"
        type="main"
        @click.native="onSubmit"
      />

      <AppButton
        title="Отмена"
        type="alt"
        @click.native="leavePage"
      />
    </div>

    <ThePagePreloader v-if="isLoading"/>

    <transition name="fade">
      <LogisticWaybillWorkModal v-show="workModal.active"
                                :state="workModal"
                                @set-item-time="setWorkTime"
                                @clear-validation="clearValidation"
                                @set-item-responsible="setWorkResponsible"
                                @set-item-description="setWorkDescription"
                                @set-item-type="setWorkType"
                                @close-modal="closeWorkModal"
                                @save-item-info="SAVE_WAYBILL_UPDATE_WORK_MODAL"
      />
    </transition>
  </main>
</template>

<script>
import AppButton from '@/components/page/button/AppButton'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import AppInput from '@/components/page/input/AppInput'
import AppInputDate from '@/components/page/input/AppInputDate'
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import AppTable from '@/components/page/table/AppTable'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'
import LogisticWaybillWorkModal from '@/components/logistic/LogisticWaybillWorkModal'
import LogisticWaybillFuels from '@/components/logistic/LogisticWaybillFuels'
import AppBack from '@/components/page/AppBack'
import AppPageHeader from '@/components/page/AppPageHeader'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import Validation from '@/components/page/Form/Validation'
import VSelect from '@/components/page/Form/VSelect'

export default {
  name: 'LogisticWaybillUpdate',
  components: {
    VSelect,
    Validation,
    AppPageHeader,
    LogisticWaybillFuels,
    LogisticWaybillWorkModal,
    AppNoRecordsPlaceholder,
    AppTable,
    AppButtonSmRemove,
    AppButtonSmAdd,
    AppInputDate,
    AppInput,
    AppButton,
    ThePagePreloader,
    AppBack
  },

  data () {
    return {
      isCreate: false
    }
  },

  computed: {
    ...mapState('handbook/logistic', {
      driverList: 'driverList'
    }),
    ...mapGetters('handbook/logistic', {
      transportList: 'transportList'
    }),

    ...mapState('logistic/waybillUpdate', {
      waybill: 'waybill',
      driverTransports: 'transports',
      isLoading: 'isLoading',
      workModal: 'workModal',
      workIsActiveDelete: 'workIsActiveDelete',
      workHeaders: 'workTableHeader',
      validation: 'validation'
    }),
    ...mapGetters('logistic/waybillUpdate', {
      waybillDriverTransports: 'waybillDriverTransports',
      work: 'getWaybillUpdateWork'
    })
  },

  async mounted () {
    const id = this.$router.history.current.params.id
    this.setInitialState()

    if (id === 'create') {
      this.isCreate = true
    } else {
      this.isCreate = false
      await this.loadItem(id)
    }

    await Promise.all([
      this.GETLogisticTransportList(),
      this.GETLogisticDriverList()
    ])
  },

  methods: {
    ...mapActions('handbook/logistic', {
      GETLogisticTransportList: 'GETLogisticTransportList'
    }),
    GETLogisticDriverList ({ search = null } = {}) {
      return this.$store.dispatch(
        'handbook/logistic/GETLogisticDriverList',
        {
          expand: 'transport,default_car',
          search
        })
    },
    ...mapMutations('logistic/waybillUpdate', {
      setInitialState: 'SET_WAYBILL_UPDATE_INITIAL_STATE',
      setDateAt: 'SET_WAYBILL_UPDATE_DATE_AT',
      setCode: 'SET_WAYBILL_UPDATE_CODE',
      setStartAt: 'SET_WAYBILL_UPDATE_START_AT',
      setEndAt: 'SET_WAYBILL_UPDATE_END_AT',
      openWorkModal: 'OPEN_WAYBILL_UPDATE_WORK_MODAL',
      closeWorkModal: 'CLOSE_WAYBILL_UPDATE_WORK_MODAL',
      setWorkTime: 'SET_WAYBILL_UPDATE_WORK_TIME',
      setWorkResponsible: 'SET_WAYBILL_UPDATE_WORK_RESPONSIBLE',
      setWorkDescription: 'SET_WAYBILL_UPDATE_WORK_DESCRIPTION',
      setWorkType: 'SET_WAYBILL_UPDATE_WORK_TYPE',
      deleteSelectedWorks: 'DELETE_WAYBILL_UPDATE_WORK_ITEMS',
      setBalanceAdd: 'SET_WAYBILL_UPDATE_BALANCE_ADD',
      setBalanceAt: 'SET_WAYBILL_UPDATE_BALANCE_AT',
      setBalanceTo: 'SET_WAYBILL_UPDATE_BALANCE_TO',
      clearValidation: 'CLEAR_WAYBILL_UPDATE_VALIDATION',
      toggleActiveItem: 'TOGGLE_WAYBILL_UPDATE_CHECK_WORK_ITEM',
      toggleActiveAll: 'TOGGLE_WAYBILL_UPDATE_WORK_ACTIVE_ALL',
      SAVE_WAYBILL_UPDATE_WORK_MODAL: 'SAVE_WAYBILL_UPDATE_WORK_MODAL'
    }),

    ...mapActions('logistic/waybillUpdate', {
      loadItem: 'getWaybillUpdate',
      setDistanceStart: 'setWaybillUpdateDistanceStart',
      setDistanceEnd: 'setWaybillUpdateDistanceEnd',
      setDriver: 'setWaybillUpdateDriver',
      setTransport: 'setWaybillUpdateTransport',
      saveWaybillInfo: 'saveWaybillUpdate'
    }),

    onSubmit () {
      let invalid = false
      if (!this.$refs.driver.validate()) {
        invalid = true
      }
      if (!this.$refs.transport.validate()) {
        invalid = true
      }
      if (invalid) return

      this.saveWaybillInfo()
    },
    leavePage () {
      this.$router.push({ name: 'LogisticWaybillList' })
    }
  }
}
</script>

<style lang="scss" scoped>
.waybill {
  &__distance-set {
    color: #697178;
    font-size: 12px;

    strong {
      font-size: 14px;
      color: black;
    }
  }
}
</style>
